'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/Shared/Previously Relocated Items/Security/workspace/nb2-webpack3/node_modules/querystring-es3/index.js
// module id = 136
// module chunks = 0 1 4